export default "__VITE_ASSET__60I8A0ha__"